import axios from "axios";

const domain = window.location.hostname;
let baseURL;
if (domain === '127.0.0.1' || domain === 'localhost') {
    baseURL = 'http://127.0.0.1:8081/api';
} else if (domain === 'admin.goertrip.club' || domain === 'www.admin.goertrip.club') {
    baseURL = 'https://api.ozilconnect.com/api';
} else if (domain === 'admin.holidayfly.in' || domain === 'www.admin.holidayfly.in') {
    baseURL = 'https://api.ozilconnect.com/api';
} else if (domain === 'admin.ozilcrm.com' || domain === 'www.admin.ozilcrm.com') {
    baseURL = 'https://api.ozilcrm.com/api';
} else {
    baseURL = 'http://127.0.0.1:8081/api';
}
const api = axios.create({
    // baseURL: "http://127.0.0.1:8081/api",
    // baseURL: "https://api.ozilconnect.com/api",
    baseURL: baseURL,
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        // console.log(token);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// export const login = async (credentials) => {
//   try {
//     const response = await api.post('/login', credentials);
//     console.log(response.data);

//     return response.data;
//   } catch (error) {
//     throw error.response.data;
//   }
// };

export const login = async (credentials) => {
    try {
        const response = await api.post("/login", credentials);
        return response.data;
    } catch (error) {
        // Handle 401 Unauthorized (Invalid Credentials)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid Credentials",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Login failed. Please try again.",
        };
    }
};

export const getProfile = async () => {
    try {
        const response = await api.get("/user");
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const logout = async () => {
    try {
        await api.post("/logout");
    } catch (error) {
        console.error("Logout error:", error);
    }
};

export const createuser = async (credentials) => {
    try {
        const response = await api.post("/customer/create", credentials);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid Credentials)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid Credentials",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const getUserlist = async (perPage, page = 1, keyword = null, userIds = []) => {
    try {
        const response = await api.post(`/customer/fetch?per_page=${perPage}&page=${page}&keyword=${keyword}`,
            {
                userIds: userIds,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const getLoyaltyCard = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/loyalty_card?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        // const response = await api.post(`/loyalty/loyalty_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyCardUnAssign = async (perPage, page = 1, cardNumbers = [], keyword = null) => {
    try {
        const response = await api.post(
            `/loyalty/loyalty_card_unassign?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
                keyword: keyword,
            }
        );
        // const response = await api.post(`/loyalty/loyalty_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyUserCard = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/user_card?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        //const response = await api.post(`/loyalty/user_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyRewards = async (perPage, page = 1) => {
    try {
        const response = await api.post(`/loyalty/reward?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyRedemption = async (perPage, page = 1) => {
    try {
        const response = await api.post(`/loyalty/redemptionhistory?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyProgram = async () => {
    try {
        const response = await api.post(`/loyalty/program`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const creatLoyalitycard = async (details) => {
    try {
        const response = await api.post("/loyalty/addcard", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatLoyalityReward = async (details) => {
    console.log(details);

    try {
        const response = await api.post("/loyalty/addreward", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatLoyalityAssign = async (details) => {
    console.log(details);

    try {
        const response = await api.post("/loyalty/assign", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const creatstore = async (details) => {
    try {
        const response = await api.post("/store/create", details, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid details)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid details",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const importcustomer = async (details) => {
    try {
        const response = await api.post("/customer/importcustomer", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid details)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid details",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const fetchstores = async (perPage, page = 1, keyword = null) => {
    try {
        const response = await api.post(`/store/fetch?per_page=${perPage}&page=${page}&keyword=${keyword}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const fetchcountries = async () => {
    try {
        const response = await api.post(`/country`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const fetchstates = async (value) => {
    try {
        const response = await api.post("/states", { countryid: value });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const fetchcities = async (stateid, countryid) => {
    try {
        const response = await api.post("/cities", { stateid: stateid, countryid: countryid });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};


export const getLoyaltyReport = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreport?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyReportCustomer = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreportcustomer?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyReportReward = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreportreward?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getEarningByCustomer = async (perPage, page = 1, filters = []) => {
    try {
        const response = await api.post(
            `/loyalty/earningbycustomer?per_page=${perPage}&page=${page}`, // URL with query params
            {
                filters: filters,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const CompareFaces = async (imageData) => {
    try {
        const response = await api.post("/customer/face-compare", imageData, {
            headers: {
                "Content-Type": "application/json"
            },
        });
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const SendPasswordAPI = async (id) => {
    try {
        const response = await api.post(`/manage-user/sendpassword/${id}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === 'Unauthenticated') {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export default api;
